import { render, staticRenderFns } from "./Home_Footer.vue?vue&type=template&id=15c9464e&scoped=true&"
import script from "./Home_Footer.vue?vue&type=script&lang=js&"
export * from "./Home_Footer.vue?vue&type=script&lang=js&"
import style0 from "./Home_Footer.vue?vue&type=style&index=0&id=15c9464e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c9464e",
  null
  
)

export default component.exports